import { types } from "mobx-state-tree";

export const ModalStore = types
  .model({
    show: types.optional(types.boolean, false),
    
    mode: types.maybeNull(types.string), // create | edit
    entityId: types.maybeNull(types.integer),

    isSubmitting: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    toggle() {
      self.show = !self.show;
    },

    setMode(newMode) {
      self.mode = newMode;
    },

    setEntityId(id) {
      self.entityId = id;
    },

    setSubmitState(bool) {
      self.isSubmitting = bool;
    },
  }));
